import { createSlice } from '@reduxjs/toolkit'
import { strapiFetch, StrapiApiError } from '../../api/strapi'

const slice = createSlice({
    name: 'about',
    initialState: {
        data: null,
        loading: false,
        loaded: false,
        error: null,
    },
    reducers: {
        setLoading: (state, action) => { state.loading = action.payload },
        setLoaded: (state, action) => { state.loaded = action.payload },
        setData: (state, action) => { state.data = action.payload },
        setError: (state, action) => { state.error = action.payload },
    },
})

export default slice.reducer

const { setLoading, setLoaded, setData, setError } = slice.actions

export const loadAboutData = (locale) => async dispatch => {
    dispatch(setLoading(true))
    dispatch(setError(null))
    try {
        const json = await strapiFetch('/api/about-page', {
            locale,
            params: {
                'populate[seo]': 'true',
                'populate[banner][populate][bannerImage]': 'true',
                'populate[companySection][populate][image]': 'true',
                'populate[teamSection][populate][image]': 'true',
                'populate[gallery][populate][image]': 'true',
            },
        })
        dispatch(setData(json.data))
        dispatch(setLoaded(true))
    } catch (e) {
        dispatch(setError(e instanceof StrapiApiError ? e.message : 'Failed to load about page'))
    } finally {
        dispatch(setLoading(false))
    }
}
